import { ReactElement } from 'react'
import { ColorRepresentation, DoubleSide } from 'three'
import { Instances, Instance } from '@react-three/drei'
import { ThreeEvent } from '@react-three/fiber'

interface Props {
  group: InstancedTransmitterGroup
  onClickItem?: (event: ThreeEvent<MouseEvent>, item: ElementSupportItem) => void
  color: ColorRepresentation
  hiddenElementGuids?: string[]
}

const InstancedTransmitterGroup = ({
  group,
  onClickItem,
  color,
  hiddenElementGuids,
}: Props): ReactElement => {
  return (
    <Instances key={length} boundingSphere={group.sphere}>
      <bufferGeometry>
        <bufferAttribute
          attach="attributes-position"
          array={group.vertices}
          count={group.vertices.length / 3}
          itemSize={3}
        />
        <bufferAttribute
          attach="index"
          array={group.indices}
          count={group.indices.length}
          itemSize={1}
        />
      </bufferGeometry>

      <meshStandardMaterial
        polygonOffset
        polygonOffsetUnits={-2000}
        color={color}
        opacity={0.4}
        transparent={true}
        side={DoubleSide}
        depthWrite={false}
      />

      {group.items.map((item, itemIndex) => (
        <Instance
          key={`${length}-${itemIndex}`}
          onClick={onClickItem ? event => onClickItem(event, item.target.item) : undefined}
          matrix={item.matrix}
          matrixAutoUpdate={false}
          visible={
            !hiddenElementGuids || !hiddenElementGuids.includes(item.target.item.element_guid)
          }
        />
      ))}
    </Instances>
  )
}

export default InstancedTransmitterGroup
